import cn from 'classnames';
import Skeleton from 'react-loading-skeleton';

import Text from 'components/common/Text';
import CutOffDateAndTime from 'components/signUpFunnel/thankYou/CutOffDateAndTime';
import ThankYouButton from 'components/signUpFunnel/thankYou/ThankYouButton';
import useBrand from 'hooks/useBrand';
import { TEMPO } from 'lib/constants';
import styles from 'styles/components/signUpFunnel/thankYou/NextSteps';

const NextSteps = ({ basket, brand, firstDeliveryDateFormatted, onClick, postSignupUrl, user }) => {
  const isTempo = useBrand(TEMPO);

  const NextStepsContent = () => {
    return (
      <>
        <div
          className={cn(
            'flex flex-col items-center px-4 pb-8 text-center',
            styles.smartphoneNextSteps,
            styles[brand],
            {
              'bg-cream-110': !isTempo,
              'bg-tempo-gray-100': isTempo,
            }
          )}
        >
          <Text brandStylesOverrides="h5 text-tempo-black-100">
            Your first box will be delivered on
          </Text>
          <Text brandStylesOverrides="h3 font-medium text-primary" className="mb-4">
            {basket ? firstDeliveryDateFormatted : <Skeleton className={styles.skeleton150} />}
          </Text>
          <div className="flex items-center">
            <CutOffDateAndTime />
          </div>
          <Text brandStylesOverrides="textSm text-tempo-black-100" className="mt-1">
            Heads up! You'll receive our pre-selected meals if you don't make changes before that
            date.
          </Text>
          <div className="mt-2">
            <ThankYouButton
              onClick={onClick}
              postSignupUrl={postSignupUrl}
              user={user}
              variant="primary"
              buttonStyles="w-[345px] min-[376px]:w-96"
            />
          </div>
        </div>
      </>
    );
  };

  return <NextStepsContent />;
};

NextSteps.propTypes = {
  basket: PropTypes.object.isRequired,
  brand: PropTypes.string.isRequired,
  firstDeliveryDateFormatted: PropTypes.string.isRequired,
  isSmartphoneScreenSize: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  postSignupUrl: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
};

export default NextSteps;
